// extracted by mini-css-extract-plugin
module.exports = {"title":"AppointmentStatusForm_title__2egRh","fieldContainer":"AppointmentStatusForm_fieldContainer__2eGYt","fieldError":"AppointmentStatusForm_fieldError__1FdvF"};